import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import App from './modules/App.jsx';
import MobileApp from './modules/mobile/MobileApp';
import configureStore from "./modules/store/configureStore";
import { isMobile } from './utils/deviceDefinition';

require('./style.css');
// require('../../node_modules/jquery/dist/jquery.min');
require('../../node_modules/jquery.inputmask/dist/jquery.inputmask.bundle');

const store = configureStore();
const APPOINTMENT_DISABLED = false; // Change this to false for enable app

render(
  <Provider store={store}>
    {
      isMobile()
        ? <MobileApp appointmentDisabled={APPOINTMENT_DISABLED}/>
        : <App appointmentDisabled={APPOINTMENT_DISABLED}/>
    }
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// frontend/src/main.jsx